import { m } from '@sohanscript/i18n';
import type { LinkProps } from '#/components/link.tsx';

export type NavItemConfig = {
	labelKey: string;
	href: string;
	subhref: string;
	icon: string;
	opts?: LinkProps & { footerOnly?: boolean };
};

export const NAV_ITEMS: NavItemConfig[] = [
	{
		labelKey: 'nav_works',
		href: '/works',
		subhref: '/work',
		icon: 'lucide:briefcase',
	},
	{
		labelKey: 'nav_notes',
		href: '/notes',
		subhref: '/note',
		icon: 'lucide:notebook',
	},
	{
		labelKey: 'nav_services',
		href: '/services',
		subhref: '/build',
		icon: 'lucide:wrench',
	},
];

export const NAV_FOOTER_ITEMS: NavItemConfig[] = [
	{
		labelKey: 'nav_resume',
		href: '/resume',
		subhref: '/resume',
		icon: 'lucide:file-user',
		opts: { footerOnly: true },
	},
	{
		labelKey: 'nav_contact',
		href: '/start',
		subhref: '/start',
		icon: 'lucide:send',
		opts: { footerOnly: true },
	},
];

export const NAV_BRAND_ITEMS: Record<'fiverr' | 'upwork', NavItemConfig> = {
	fiverr: {
		labelKey: 'Fiverr',
		href: '/fiverr',
		subhref: '/fiverr',
		icon: 'lucide:star',
		opts: { noRef: true, target: '_blank' },
	},
	upwork: {
		labelKey: 'Upwork',
		href: '/upwork',
		subhref: '/upwork',
		icon: 'lucide:rocket',
		opts: { noRef: true, target: '_blank' },
	},
};

/** Resolves a nav label key to its localized text; brand names pass through. */
export function getNavLabel(labelKey: string): string {
	const message = (m as unknown as Record<string, () => string>)[labelKey];
	return message ? message() : labelKey;
}
